// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".review-user[data-v-7b8a7a4c]{display:flex;flex-direction:column;flex-grow:1;gap:8px}.review-user__name[data-v-7b8a7a4c]{height:13px}.review-user__name>span+span[data-v-7b8a7a4c]{margin-left:8px}.review-user__time[data-v-7b8a7a4c]{word-break:keep-all}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
